/**
 * Formatting utilities for display
 */

// Format date for display
export const formatDate = (date) => {
  if (!date) return '';
  return new Date(date).toLocaleDateString();
};

// Format number for display
export const formatNumber = (number) => {
  if (!number && number !== 0) return '';
  return number.toLocaleString();
};

// Truncate text for display
export const truncateText = (text, maxLength = 50) => {
  if (!text) return '';
  return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
};

// Format cell value based on column type
export const formatCellValue = (value, columnType) => {
  if (!value && value !== 0 && value !== false) return '';
  
  switch (columnType) {
    case 'date':
      return formatDate(value);
    case 'number':
      return formatNumber(value);
    case 'textarea':
      return truncateText(value, 100);
    case 'checkbox':
      return value === true ? '✓' : '✗';
    case 'checklist':
      if (Array.isArray(value)) {
        const checkedCount = value.filter(Boolean).length;
        const totalCount = value.length;
        return `${checkedCount}/${totalCount} checked`;
      }
      return '';
    default:
      return truncateText(value);
  }
};

// Get input type for column type
export const getInputType = (columnType) => {
  switch (columnType) {
    case 'number':
      return 'number';
    case 'date':
      return 'date';
    default:
      return 'text';
  }
};
